/**
 * Shared axios instance and API configuration.
 */

import axios from 'axios';
import { Configuration } from './generated';

function addInactiveUserInterceptor(instance: ReturnType<typeof axios.create>) {
  instance.interceptors.response.use(undefined, (error) => {
    if (error?.response?.status === 403 && error.response.data?.code === 'account_inactive') {
      localStorage.setItem('auth_error', 'inactive');
    }
    return Promise.reject(error);
  });
}

// Axios instance with session auth support
export const axiosInstance = axios.create({
  baseURL: '',
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});
addInactiveUserInterceptor(axiosInstance);

// Configuration for generated API clients
export const apiConfig = new Configuration({
  basePath: '',
  baseOptions: {
    withCredentials: true,
  },
});
